import React from "react";
import { Modal } from "antd";

interface Props {
  documentUrl: string | null;
  isDocumentModalVisible: boolean;
  closeModal: () => void;
}

const DocumentViewerModal: React.FC<Props> = ({ documentUrl, isDocumentModalVisible, closeModal }) => {
  return (
    <Modal
      title="Document Viewer"
      open={isDocumentModalVisible}
      onCancel={closeModal}
      footer={null}
      width="80vw" // 80% of the viewport width
      style={{ top: 20 }} // Adjust position for better responsiveness
    >
      {documentUrl ? (
        <iframe
          src={documentUrl}
          title="Document Viewer"
          width="100%"
          height={window.innerHeight * 0.7} // 70% of the viewport height
          className="border border-gray-300"
        />
      ) : (
        <p>No document available.</p>
      )}
    </Modal>
  );
};

export default DocumentViewerModal;
